module.exports = __webpack_public_path__ + "static/img/info_button3_inactive.6c3e6ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_button3_inactive.png
// module id = +5/E
// module chunks = 4